/**
 * Exponente ISO 4217 (minor units) para monedas que Vuelto usa o planea usar.
 * Default 2 para códigos desconocidos (USD-like).
 */
const FRACTION_DIGITS_BY_CURRENCY: Record<string, number> = {
  ARS: 2,
  USD: 2,
  EUR: 2,
  MXN: 2,
  BRL: 2,
  UYU: 2,
  PYG: 0,
  CLP: 0,
  COP: 2,
  PEN: 2,
  BOB: 2,
  CRC: 2,
  GTQ: 2,
  HNL: 2,
  NIO: 2,
  PAB: 2,
  DOP: 2,
  VES: 2,
  JPY: 0,
  KRW: 0,
};

export function fractionDigitsForCurrency(currencyCode: string | null | undefined): number {
  const code = (currencyCode ?? '').trim().toUpperCase();
  if (!code) return 2;
  const digits = FRACTION_DIGITS_BY_CURRENCY[code];
  return digits ?? 2;
}
